/*eslint-disable*/
import React from "react";
import {isMobile} from 'react-device-detect';

function LightHeader() {
  return (
    <>
      <div style={{marginTop: 70}}>
        <div className="">
        {
            isMobile ? 
              window.innerWidth < 600 ? 
              (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-light-mobile.png")}
                ></img>
              ) : (
                <img
                    alt="header-home"
                    src={require("assets/img/capa-light-1024.png")}
                ></img>
              )
            : (
              <img
                  alt="header-home"
                  src={require("assets/img/capa-light.jpg")}
              ></img>
            )
          }
        </div>
      </div>
    </>
  );
}

export default LightHeader;